import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Layout, PageHeader, UnvButton, UnvModal, UnvInput, Spinner, Icon, Card } from "components";
import AlertCardMain from 'pages/MainPage/components/AlertCard/AlertCardMain'
import NewsCard from "./components/NewsCard";
import { TextareaAutosize } from "@mui/material";
import userInfo from "utils/userInfo";
import AlertCard from "./components/AlertCard/AlertCard";
import { PostNews } from "service/AlertService";
import { postNewNews } from "store/slices/AlertSlice";
import Notification from "utils/Notifications";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import styles from "./MainPage.module.scss";
import Weather from "./components/WeatherCard/Weather";


function MainPage() {
  const { t } = useTranslation('common')
  const user = userInfo();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [file, setFile] = useState([]);
  const [loader, setLoader] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [title_news, setTitle_news] = useState("");
  const [discrip, setDiscrip] = useState("");
  const [url_news, setUrl_news] = useState("");
  const [url_video, setUrl_video] = useState("");

  const [width, setWidth] = useState(window.innerWidth);
  const onFileChange = (event) => {
    setFile(event.target.files);
  };
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // FIX: useEffect без deps выполнялся каждый рендер — добавили [width].
  useEffect(() => {
    width < 600 && handleSideNavToggle();
  }, [width]);
  function handleSideNavToggle() {
  }
  const [refreshKey, setRefreshKey] = useState(0);
  const dispatch = useDispatch();
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (title_news === "") {
      setNotify({
        isOpen: true,
        message: t('main.missing_title'),
        type: "warning", sound: 'warning'
      });
    } else if (discrip === "") {
      setNotify({
        isOpen: true,
        message: t('main.missing_description'),
        type: "warning", sound: 'warning'
      });
    } else {
      try {
        setLoader(true);
        const formData = new FormData();
        formData.append('title', title_news);
        formData.append('description', discrip);
        formData.append('url_news', url_news);
        formData.append('url_video', url_video);

        for (let i = 0; i < file.length; i++) {
          formData.append('files', file[i]);
        }

        let response = await PostNews(formData);

        dispatch(
          postNewNews({
            title: title_news,
            description: discrip,
            file: file ? file.name : null,
            url_news: url_news,
            url_video: url_video,
          })
        );

        setNotify({
          isOpen: true,
          message: t('main.news_published'),
          type: "success", sound: "success"
        });
        // FIX: убрали window.location.reload() — используем refreshKey-паттерн.
        setOpenModal(false);
        setTitle_news("");
        setDiscrip("");
        setUrl_news("");
        setUrl_video("");
        setFile([]);
        setRefreshKey((k) => k + 1);
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
        });
      } finally {
        setLoader(false);
      }

    }
  };
  const navigate = useNavigate()
  const Greeting = () => {
    const currentTime = new Date().getHours();

    const getRandomItem = (array) => {
      return array[Math.floor(Math.random() * array.length)];
    };

    const greetings = {
      morning: [t('main.morning_1'), t('main.morning_2'), t('main.morning_3')],
      afternoon: [t('main.afternoon_1'), t('main.afternoon_2'), t('main.afternoon_3')],
      evening: [t('main.evening_1'), t('main.evening_2'), t('main.evening_3')],
      night: [t('main.night_1'), t('main.night_2'), t('main.night_3')],
    };

    let greeting = '';
    if (currentTime < 12 && currentTime > 5) {
      greeting = getRandomItem(greetings.morning);
    } else if (currentTime < 18 && currentTime > 11) {
      greeting = getRandomItem(greetings.afternoon);
    } else if (currentTime < 22 && currentTime > 17) {
      greeting = getRandomItem(greetings.evening);
    } else {
      greeting = getRandomItem(greetings.night);
    }

    return <div>{greeting}</div>;
  };
  const headerActions = (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {user?.is_admin_of_news && (
        <UnvButton variant="primary" iconLeft="plus" onClick={() => setOpenModal(true)}>
          {t('main.create_news')}
        </UnvButton>
      )}
      {user?.is_admin_of && (
        <UnvButton variant="secondary" iconLeft="settings" onClick={() => navigate('/admin_organizations/')}>
          {t('main.administration')}
        </UnvButton>
      )}
    </div>
  )

  return (
    <Layout>
      <div className={styles.main_wrapper}>
        <PageHeader
          icon={<Icon name="home" size={28} />}
          title={<span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{Greeting()}<span style={{ color: 'var(--color-accent)' }}>{user?.firstName}</span>!</span>}
          subtitle={t('auto.mainpage.subtitle', 'Главная страница: новости, погода, объявления')}
          actions={headerActions}
        />
        <div className={styles.news_wrapper}>
          <div className={styles.news_welcome_wrapper_div}>
            <div className={styles.news_welcome_wrapper}>
              <AlertCardMain />
            </div>
            <div className={styles.news_welcome_wrapper}>
              <Weather />
            </div>
          </div>
          {width <= 1080 && <h2 style={{ marginTop: 12 }}>{t('main.alerts')}</h2>}
          {width > 1080 ? <NewsCard key={refreshKey} /> : <AlertCard key={refreshKey} />}
          {width < 1080 && (
            <div style={{ marginTop: 16 }}>
              <h2>{t('main.news')}</h2>
              <NewsCard key={refreshKey} />
            </div>
          )}
        </div>
      </div>
      <UnvModal open={openModal} onClose={() => setOpenModal(false)} title={t('main.add_news')} size="md">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <UnvInput
            label={t('main.title')}
            placeholder={t('main.title_placeholder')}
            value={title_news}
            onChange={(e) => setTitle_news(e.target.value)}
          />
          <div>
            <label style={{ display: 'block', marginBottom: 4, fontSize: 14, color: 'var(--color-text-muted)' }}>{t('main.description')}</label>
            <TextareaAutosize
              minRows={3}
              placeholder={t('main.description_placeholder')}
              className={styles.discription_input}
              value={discrip}
              onChange={(e) => setDiscrip(e.target.value)}
            />
          </div>
          <UnvInput
            label={t('main.links_hint')}
            placeholder={t('main.link_placeholder')}
            value={url_news}
            onChange={(e) => setUrl_news(e.target.value)}
          />
          <UnvInput
            label={t('main.youtube_link')}
            placeholder={t('main.youtube_placeholder')}
            value={url_video}
            onChange={(e) => setUrl_video(e.target.value)}
          />
          <div>
            <label style={{ display: 'block', marginBottom: 4, fontSize: 14, color: 'var(--color-text-muted)' }}>{t('main.files_label')}</label>
            <div className={styles.add_statement_file}>
              <input type="file" multiple onChange={onFileChange} />
              <span>{t('main.attach_file')}</span>
            </div>
          </div>
        </div>
        <UnvModal.Footer>
          <UnvButton variant="ghost" onClick={() => setOpenModal(false)} disabled={loader}>{t('common.close')}</UnvButton>
          <UnvButton variant="primary" iconLeft="send" onClick={handleSubmit} loading={loader}>{t('common.send_action')}</UnvButton>
        </UnvModal.Footer>
      </UnvModal>
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  );
}

export default MainPage;
